import { useCurrentAccount, useCurrentWorkspace } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Button } from 'react-native-paper';
import { useNavigate } from 'react-router-dom';

export const RoutinesToolbar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const workspace = useCurrentWorkspace();
  const { account } = useCurrentAccount();

  const routeToNewRoutine = () => {
    navigate('/new-routines/new');
  };

  // Only show the toolbar for global admins
  if (!account?.isGlobalAdmin()) {
    return null;
  }

  return (
    <Button
      icon="plus"
      style={styles.button}
      labelStyle={styles.buttonLabel}
      onPress={routeToNewRoutine}
      // buttonColor={Colors.primary}
      mode="text"
    >
      {t('routines.createNew')}
    </Button>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    height: 151,
    borderRadius: 12,
    backgroundColor: Colors.white,
    marginBottom: 20,
    justifyContent: 'flex-end',
    paddingRight: 30,
    alignItems: 'center',
  },
  inner: {
    flexDirection: 'column',
  },
  button: {
    borderRadius: 8,
    width: '100%',
    maxWidth: 256,
    height: 44,
    justifyContent: 'center',
  },
  buttonLabel: {
    fontSize: 16,
    fontWeight: '500',
    color: Colors.primaryDark,
  },
});
